import { Box, Card, Grid, pn, Stack, Typography, useElementBreakpoints } from "@compass/core";
import PieChart, { Legend, Series } from "devextreme-react/pie-chart";
import { ObjectiveReportsEligibilityCriteria, TupleOfStringAndInteger } from "generated/openApi";

export const ObjectiveEligibilityCriteria = (props: {
  title: string;
  objective: ObjectiveReportsEligibilityCriteria;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  return (
    <Card header={props.title}>
      <Grid ref={breakpointsRef} container spacing="lg" maxWidth="1000px">
        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })}>
          <Box maxWidth="100%">
            <PieChart
              dataSource={props.objective.data}
              onPointHoverChanged={(pointInfo: any) => {
                if (pointInfo.target.isHovered()) {
                  pointInfo.target.showTooltip();
                } else {
                  pointInfo.target.hideTooltip();
                }
              }}
              palette="Soft Blue"
            >
              <Series
                argumentField={pn<TupleOfStringAndInteger>("item1")}
                valueField={pn<TupleOfStringAndInteger>("item2")}
              >
                {/* <Label visible={true} /> */}
              </Series>

              <Legend
                visible={true}
                orientation="vertical"
                verticalAlignment="top"
                horizontalAlignment="center"
                itemTextPosition="right"
              //rowCount={2}
              />
            </PieChart>
          </Box>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Grid container spacing="sm">
            <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
              <Stack spacing="md" justifyContent={"center"} alignItems="center">
                <Typography variant="body1" textAlign={"center"}>
                  Year
                </Typography>
                <Typography variant="h6">
                  {props.objective.year}/{props.objective.year + 1}
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
              <Stack spacing="md" justifyContent={"center"} alignItems="center">
                <Typography variant="body1" textAlign={"center"}>
                  Program
                </Typography>
                <Typography variant="h6">
                  {props.objective.program}
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
              <Stack spacing="md" justifyContent={"center"} alignItems="center">
                <Typography variant="body1" textAlign={"center"}>
                  {props.objective.lowIncomeAndFirstGenerationCollegeStudentLabel}
                </Typography>
                <Typography variant="h6">
                  {(props.objective.lowIncomeAndFirstGenerationCollegeStudentProportion * 100).toFixed(2)}%
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={setBreakpoints({ md: 6, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
              <Stack spacing="md" justifyContent={"center"} alignItems="center">
                <Typography variant="body1" textAlign={"center"}>
                  Participants Served
                </Typography>
                <Typography variant="h6">{props.objective.participantsServed}</Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>



      {/* <Stack spacing="md">
          <Typography variant="h6">{props.objective.eligibleLabel}</Typography>
          <Typography variant="h5">{props.objective.eligibleStudents}</Typography>
        </Stack> */}

      {/* <pre>{JSON.stringify(props.objective, null, 4)}</pre> */}
    </Card>
  );
};
